import { render, staticRenderFns } from "./invite-user-tab.vue?vue&type=template&id=c77c2580"
import script from "./invite-user-tab.vue?vue&type=script&lang=js"
export * from "./invite-user-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports